import { store } from "../../store/store";
import { setSessionProgress } from "../../store/slices/session.slice";

const taskProgressService = {
	handleProgress(data: { progress: number }) {
		store.dispatch(setSessionProgress(data.progress));
	},
	handleRejected() {
		store.dispatch(setSessionProgress(0));
	},
};

export default taskProgressService;
